import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material'

import { isNullorEmpty } from '@/utils'

function Inputs({ recipe }) {
  return (
    <>
      <Table sx={{ width: '100%', tableLayout: 'fixed', color: 'black' }}>
        <TableHead>
          <TableRow>
            <TableCell sx={{ color: 'black' }} />
            <TableCell sx={{ color: 'black' }}>
              <Typography fontWeight="bold" color="black">
                Cervical
              </Typography>
            </TableCell>
            <TableCell sx={{ color: 'black' }}>
              <Typography fontWeight="bold" color="black">
                Middle
              </Typography>
            </TableCell>
            <TableCell sx={{ color: 'black' }}>
              <Typography fontWeight="bold" color="black">
                Incisal
              </Typography>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell sx={{ color: 'black' }}>
              <Typography fontWeight="bold" color="black">
                Target
              </Typography>
            </TableCell>
            <TableCell sx={{ color: 'black' }}>
              {isNullorEmpty(recipe.provided_input, 'targetcervical')
                ? recipe.provided_input.targetcervical
                : '-'}
            </TableCell>
            <TableCell sx={{ color: 'black' }}>
              {isNullorEmpty(recipe.provided_input, 'targetmiddle')
                ? recipe.provided_input.targetmiddle
                : '-'}
            </TableCell>
            <TableCell sx={{ color: 'black' }}>
              {isNullorEmpty(recipe.provided_input, 'targetincisal')
                ? recipe.provided_input.targetincisal
                : '-'}
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>

      <hr style={{ background: 'black', opacity: 1, margin: 0 }} />
    </>
  )
}

export default Inputs
